import { useClient } from '../../../../react-hooks/useClient';
import { getUserClient } from '../../../../react-hooks/useUserClient';
import {
    mapChoicesToOptions,
    sortFieldOptions,
} from '../utils/fieldOptions';

export async function fetchTeaserFieldOptions({
    modelIdentifier,
    extraFields = [],
    hiddenFields = new Set([]),
} = {}) {
    const client = useClient();
    const userClient = getUserClient();
    const instance = userClient?.getUser?.()?.instance;

    if (!client || !instance?.id) {
        console.warn(
            '[teaserFields] Missing client or instance; field options empty'
        );
        return sortFieldOptions(extraFields);
    }

    try {
        const response = await client.post(
            'form/config/instance/manage-hidden-fields',
            {
                modelIdentifier,
                changedField: 'modelIdentifier',
                contextObj: {
                    id: instance.id,
                    modelId: instance.modelId || 'instance/instance',
                },
            }
        );

        const formFields = response?.data?.fields || [];
        const fieldsField = formFields.find(
            (field) => field?.property === 'fields'
        );

        return mapChoicesToOptions(fieldsField?.choices || [], {
            extraFields,
            hiddenFields,
        });
    } catch (error) {
        console.error('[teaserFields] Failed to load field options', error);
        return sortFieldOptions(extraFields);
    }
}
